<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="72vw" @close="handleDialogClose">
    <el-form :model="formData" :rules="rules" ref="formRef" label-position="top" label-width="120px">
      <el-form-item label="大棚编号:" prop="greenhouseId">
        <el-select
          v-model="formData.greenhouseId"
          placeholder="请选择"
          style="width: 100%"
          @change="handleGreenhouseChange"
        >
          <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="草莓品种:" prop="varietyId">
        <el-select v-model="formData.varietyId" placeholder="请选择" style="width: 100%" @change="handleVarietyChange">
          <el-option v-for="item in varietyOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生长时期:" prop="periodDetails">
        <div class="period-hint">
          <span style="color: #f56c6c"
            >提示:第一个时期名称选择开始时段后,后面日期时段自动排列,调整时期天数,后面具体日期时段可随之更新</span
          >
        </div>
        <div class="config-table">
          <el-table :data="formData.details" border style="width: 100%">
            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
            <el-table-column label="时期名称" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.basicStageName || '根据品种带出' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="判定标准">
              <template slot-scope="scope">
                <span>{{ scope.row.judgmentCriteria || '根据时期带出' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="注意事项">
              <template slot-scope="scope">
                <span>{{ scope.row.precautions || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="该时期天数(天)">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.days"
                  :min="1"
                  :precision="0"
                  size="mini"
                  style="width: 100%"
                  placeholder="请输入"
                  @change="handleDaysChange(scope.$index)"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="具体日期时段">
              <template slot-scope="scope">
                <div v-if="scope.$index === 0" style="display: flex; align-items: center">
                  <el-date-picker
                    v-model="scope.row.startDate"
                    type="date"
                    size="mini"
                    style="width: 130px"
                    placeholder="请输入开始日期"
                    @change="handleStartDateChange"
                    :class="{ 'is-error': !scope.row.startDate && formData.details && formData.details.length > 0 }"
                  >
                  </el-date-picker>
                  <div
                    v-if="scope.row.startDate && scope.row.endDate"
                    style="margin-left: 5px; color: #409eff; font-size: 12px"
                  >
                    - {{ formatDate(scope.row.endDate) }}
                  </div>
                </div>
                <div v-else>
                  <span v-if="scope.row.startDate && scope.row.endDate" style="color: #409eff">
                    {{ formatDate(scope.row.startDate) }} - {{ formatDate(scope.row.endDate) }}
                  </span>
                  <span v-else style="color: #409eff"> 自动计算 </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="状态:" prop="enabled">
        <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="handleSubmit"
        need-listen
        data-module="新增生长时期"
        data-event-name="handleSubmitGrowthPhase"
        >确定</el-button
      >
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';
import dayjs from 'dayjs';

export default {
  name: 'GrowUpDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
    greenhouseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '新增生长时期',
      formData: {
        id: '',
        greenhouseId: '',
        greenhouseName: '',
        varietyId: '',
        varietyName: '',
        details: [],
        enabled: 1,
      },
      rules: {
        greenhouseId: [{ required: true, message: '请选择大棚编号', trigger: 'change' }],
        varietyId: [{ required: true, message: '请选择草莓品种', trigger: 'change' }],
        details: [{ required: true, message: '请配置生长时期', trigger: 'change' }],
      },
      greenhouseOptions: [],
      varietyOptions: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initForm();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    },
  },
  created() {
    this.fetchGreenhouseOptions();
    this.fetchVarietyOptions();
  },
  methods: {
    initForm() {
      if (this.isEdit && this.editData.id) {
        this.dialogTitle = '编辑生长周期';
        this.formData = {
          ...this.editData,
          details: this.editData.details || [],
        };

        // 编辑模式下，如果有开始日期，重新计算各时期日期
        if (this.formData.details && this.formData.details.length > 0 && this.formData.details[0].startDate) {
          this.$nextTick(() => {
            this.calculatePeriodDates();
          });
        } else {
        }
      } else {
        this.dialogTitle = '新增生长时期';
        this.formData = {
          id: '',
          greenhouseId: this.greenhouseId || '',
          greenhouseName: '',
          varietyId: '',
          varietyName: '',
          details: [],
          enabled: 1,
        };

        // 如果传入了 greenhouseId，自动选择对应的大棚名称
        if (this.greenhouseId) {
          const selectedGreenhouse = this.greenhouseOptions.find((item) => item.value === this.greenhouseId);
          if (selectedGreenhouse) {
            this.formData.greenhouseName = selectedGreenhouse.label;
          }
        }
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
      });
    },
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.$emit('close');
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 检查第一个时期的开始日期是否已填写
          if (this.formData.details && this.formData.details.length > 0) {
            const firstPeriod = this.formData.details[0];
            if (!firstPeriod.startDate) {
              this.$message.error('请选择第一个时期的开始日期');
              return;
            }
          }

          try {
            const submitData = {
              ...this.formData,
            };
            const url = this.isEdit
              ? '/api/digital-farming/growth-cycle/edit'
              : '/api/digital-farming/growth-cycle/add';
            const res = await axios.post(baseUrl + url, submitData);
            if (res.code === 200) {
              this.$message.success(this.isEdit ? '更新成功' : '新增成功');
              this.dialogVisible = false;
              this.$emit('success');
            }
          } catch (error) {
            console.error('提交失败:', error);
          }
        }
      });
    },
    // 获取大棚选项
    async fetchGreenhouseOptions() {
      try {
        const res = await axios.post(baseUrl + '/api/basic/greenhouse/selection');
        if (res.code === 200) {
          this.greenhouseOptions = res.data.map((item) => ({
            label: item.serialNumber,
            value: item.id,
          }));
        }
      } catch (error) {}
    },
    // 获取草莓品种选项
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(baseUrl + '/api/farming/growth-stage-config/list-all', {
          enabled: 1,
        });

        if (res.code === 200) {
          this.varietyOptions = res.data.map((item) => ({
            label: item.varietyName,
            value: item.varietyId,
            configDetails: item.configDetails,
          }));
        } else {
        }
      } catch (error) {}
    },
    // 大棚变化处理
    handleGreenhouseChange(value) {
      const selectedGreenhouse = this.greenhouseOptions.find((item) => item.value === value);
      if (selectedGreenhouse) {
        this.formData.greenhouseName = selectedGreenhouse.label;
      }
    },
    // 草莓品种变化处理
    handleVarietyChange(value) {
      console.log('handleVarietyChange 被调用，选择的品种ID:', value);
      const selectedVariety = this.varietyOptions.find((item) => item.value === value);

      if (selectedVariety) {
        this.formData.varietyName = selectedVariety.label;

        // 深拷贝数据并确保响应式
        if (selectedVariety.configDetails && selectedVariety.configDetails.length > 0) {
          this.formData.details = selectedVariety.configDetails.map((item) => ({
            ...item,
            startDate: item.startDate || null,
            endDate: item.startDate || null,
            days: item.days || 1,
          }));
        } else {
          this.formData.details = [];
        }

        // 如果已经有开始日期，重新计算各时期日期
        if (this.formData.details && this.formData.details.length > 0 && this.formData.details[0].startDate) {
          this.$nextTick(() => {
            this.calculatePeriodDates();
          });
        } else {
        }
      } else {
      }
    },
    // 开始日期变化处理
    handleStartDateChange() {
      // 格式化开始日期
      if (this.formData.details && this.formData.details.length > 0) {
        const firstPeriod = this.formData.details[0];

        if (firstPeriod.startDate) {
          // 使用 $set 确保响应式更新
          this.$set(firstPeriod, 'startDate', dayjs(firstPeriod.startDate).format('YYYY-MM-DD'));

          // 确保第一个时期有天数设置
          if (!firstPeriod.days || firstPeriod.days <= 0) {
            this.$set(firstPeriod, 'days', 1);
          }
        } else {
        }
      } else {
      }

      this.calculatePeriodDates();
    },
    // 天数变化处理
    handleDaysChange(index) {
      this.calculatePeriodDates();
    },
    // 计算各时期日期
    calculatePeriodDates() {
      if (!this.formData.details || this.formData.details.length === 0) return;

      const firstPeriod = this.formData.details[0];
      if (!firstPeriod.startDate) return;

      // 确保第一个时期有天数设置
      if (!firstPeriod.days || firstPeriod.days <= 0) {
        this.$set(firstPeriod, 'days', 1);
      }

      // 格式化第一个时期的开始日期
      this.$set(firstPeriod, 'startDate', dayjs(firstPeriod.startDate).format('YYYY-MM-DD'));
      // 修复：当天数为1时，结束日期应该等于开始日期
      if (firstPeriod.days === 1) {
        this.$set(firstPeriod, 'endDate', firstPeriod.startDate);
      } else {
        this.$set(firstPeriod, 'endDate', this.addDays(firstPeriod.startDate, firstPeriod.days - 1));
      }

      for (let i = 1; i < this.formData.details.length; i++) {
        const period = this.formData.details[i];
        const prevPeriod = this.formData.details[i - 1];

        // 确保每个时期都有天数设置
        if (!period.days || period.days <= 0) {
          this.$set(period, 'days', 1);
        }

        const newStartDate = this.addDays(prevPeriod.endDate, 1);
        // 修复：当天数为1时，结束日期应该等于开始日期
        let newEndDate;
        if (period.days === 1) {
          newEndDate = newStartDate;
        } else {
          newEndDate = this.addDays(newStartDate, period.days - 1);
        }

        this.$set(period, 'startDate', newStartDate);
        this.$set(period, 'endDate', newEndDate);
      }

      // 强制更新视图
      this.$forceUpdate();
    },
    // 日期加减工具函数
    addDays(date, days) {
      if (!date) {
        return '';
      }
      // 修复：当days为0时，返回原日期
      if (days === 0) {
        return dayjs(date).format('YYYY-MM-DD');
      }
      if (!days) {
        return '';
      }
      try {
        return dayjs(date).add(days, 'day').format('YYYY-MM-DD');
      } catch (error) {
        return '';
      }
    },
    // 格式化日期显示
    formatDate(date) {
      if (!date) return '';
      return dayjs(date).format('YYYY-MM-DD');
    },
  },
};
</script>

<style scoped lang="less">
.period-hint {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #fef0f0;
  border-radius: 4px;
}

.config-table {
  .add-button-container {
    margin-top: 15px;
    text-align: center;
    padding: 15px;
    border: 2px dashed #dcdfe6;
    border-radius: 4px;
    background-color: #fafafa;
  }
}

// 添加错误状态样式
:deep(.is-error) {
  .el-input__inner {
    border-color: #f56c6c !important;
  }
}
</style>
